import { getAllMarkets } from '../hooks/useMarkets';
import { beginKeycloakAuthorization } from './keycloak-auth';
import { writeMetrcSsoRedirectState } from './metrcSsoRedirectState';

export const METRC_SSO_CALLBACK_PATH = '/imports/metrc/sso-callback';

// Starts a Metrc (Keycloak) sign-in that saves the user's tokens again and then returns to returnTo.
// The page is redirected to Keycloak, so this only resolves when the sign-in cannot start.
export async function startMetrcReauthSignIn({
  organizationId,
  marketId,
  returnTo,
}: {
  organizationId: number;
  marketId: number;
  returnTo: string;
}): Promise<void> {
  const markets = await getAllMarkets(organizationId);
  const market = markets.find((item) => Number(item.id) === Number(marketId));
  if (!market?.ssoBaseUrl || !market.ssoClientId) {
    throw new Error('Metrc sign-in is not configured for this market. Please contact support.');
  }

  writeMetrcSsoRedirectState({
    organizationId,
    marketId,
    market: market.code || market.name || '',
    ssoBaseUrl: market.ssoBaseUrl,
    ssoClientId: market.ssoClientId,
    ssoClientAuth: market.ssoClientAuth === 'confidential' ? 'confidential' : 'public',
    returnTo,
    workflow: 'reauth',
  });

  await beginKeycloakAuthorization({
    ssoBaseUrl: market.ssoBaseUrl,
    clientId: market.ssoClientId,
    redirectUri: `${window.location.origin}${METRC_SSO_CALLBACK_PATH}`,
  }, { forceLogin: false });
}
